import React from 'react'

import Image from '@/components/Image'
import Link from '@/components/Link'

const LogoLink = (link) => {
  return (
    <Link link={link.link} className='lg:grid lg:h-full '>
      <div className='flex items-center justify-between border-b border-purple-200 py-3'>
        <Image {...link.icon} className='w-full max-w-[110px] object-cover' />
        <svg
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='lg:hidden'
        >
          <g id='16 * 16'>
            <path
              id='Vector'
              d='M8.63393 13.2797L14.034 7.92955L8.77612 2.72026M1.96606 7.92722L13.8361 7.92722'
              stroke='#280C2D'
              strokeLinecap='round'
            />
          </g>
        </svg>
      </div>
    </Link>
  )
}

export default LogoLink
